class BrandPage {
    constructor() {
        this.alltypes = document.querySelector(".qc-widget.alltypes");
        this.initDeviceTypeFilter();
    }
    initDeviceTypeFilter() {
        this.cards = document.querySelectorAll(".qc-widget.devices .card");
        let items = this.alltypes?.querySelectorAll('.mdn-Radio');
        items?.forEach(elem => {
            elem.addEventListener("click", e => {
                i = this.alltypes?.querySelectorAll('.mdn-Radio');
                i.forEach(el => {
                    el.classList.remove("checked");
                    delete el.dataset.checked;
                })
                e.currentTarget.dataset.checked = "checked";
                e.currentTarget.classList.add("checked")
                this.filterDeviceType(e);
            });
        });


        let selected = document.querySelector('.alltypes .mdn-Radio.checked');
        if (selected) {
            this.filterDeviceType({
                currentTarget: selected
            });
        }
    }
    filterDeviceType(e) {
        // console.log(e);

        let content = document.querySelector(".qc-widget.devices .content");
        content.innerHTML = "";
        let i = 0;
        this.cards.forEach(el => {
            if (e.currentTarget.dataset.checked || e.currentTarget.dataset.type == "all-types") {
                if (el.dataset.type == e.currentTarget.dataset.type
                    || el.classList.contains(e.currentTarget.dataset.type)
                    || e.currentTarget.dataset.type == "all-types"
                ) {
                    i++;
                    let t = (i * 30);
                    el.style.order = i;
                    el.classList.add("vanish");
                    el.style.transitionDelay = t + "ms";
                    content.append(el);
                    setTimeout(() => {
                        el.classList.remove("vanish");
                    }, 100);

                }
            } 
        });
        eHelpFramework.widgets.DevicesWidget.reset();
    }
}

window.addEventListener("eHelpFrameworkReady", e => {
    eHelpFramework.pages.push(new BrandPage())
});